export default {"src":"/_next/static/media/arrowsin.5a773cff.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};